import { ActionType } from '@/actions';
import { ActionSetDrawNumber } from './interfaces';

export const setDrawNumber = (
  game: number,
  drawNumber: number
): ActionSetDrawNumber => {
  return {
    type: ActionType.DRAW_NUMBER_SET,
    game,
    drawNumber,
  };
};
